module.exports = __webpack_public_path__ + "static/media/higherstudiesstatistics.39041b6f.png";